// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Request from "../../core/Request.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as RequestOpenStorageUrl from "../../core/RequestOpenStorageUrl.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import Illustration_saleslistpage_export_modalSvg from "./illustration_saleslistpage_export_modal.svg";
let illustrationSvg = Illustration_saleslistpage_export_modalSvg;
let styles = {
  illustrationContainer: {
    "backgroundColor-kWkggS": "backgroundColor-x17suf5r",
    "borderRadius-kaIpWk": "borderRadius-x12oqio5",
    "display-k1xSpc": "display-x78zum5",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "padding-kmVPX3": "padding-x1o8uwn5",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/app/Sales/SalesListPageExportModal.res.js:28"
  },
  illustration: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "height-kZKoxP": "height-x1ymw6g",
    "width-kzqmXN": "width-xzk1tus",
    $$css: "wino-gc:src/app/Sales/SalesListPageExportModal.res.js:36"
  },
  filtersContainer: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "paddingBlock-k8WAf4": "paddingBlock-xd11lqx",
    "paddingInline-kg3NbH": "paddingInline-xaope02",
    $$css: "wino-gc:src/app/Sales/SalesListPageExportModal.res.js:41"
  },
  footer: {
    "borderTopColor-kLZC3w": "borderTopColor-x7i6r9d",
    "borderTopStyle-kPef9Z": "borderTopStyle-x13fuv20",
    "borderTopWidth-kEafiO": "borderTopWidth-x178xt8z",
    "display-k1xSpc": "display-x78zum5",
    "gap-kOIVth": "gap-x167g77z",
    "justifyContent-kjj79g": "justifyContent-x13a6bvl",
    "padding-kmVPX3": "padding-x1tamke2",
    $$css: "wino-gc:src/app/Sales/SalesListPageExportModal.res.js:46"
  }
};
function toLabel(value) {
  switch (value) {
    case "All":
      return I18n.t("All");
    case "InvoicesAndCreditNotes":
      return I18n.t("Invoices & credit notes");
    case "ReceiptsAndRefunds":
      return I18n.t("Receipts & refunds");
  }
}
function toRawString(value) {
  switch (value) {
    case "All":
      return I18n.t("ALL");
    case "InvoicesAndCreditNotes":
      return "INVOICES_AND_CREDIT_NOTES";
    case "ReceiptsAndRefunds":
      return "RECEIPTS";
  }
}
let values = ["InvoicesAndCreditNotes", "ReceiptsAndRefunds"];
let SalesExportSaleType = {
  toLabel: toLabel,
  toRawString: toRawString,
  values: values
};
let endpoint = Env.sheetUrl() + "/sales/sales-export";
function encodeRequestBodyJson(shopIds, startDate, endDate, exportType) {
  return Json.encodeDict(Object.fromEntries([["shopIds", Json.encodeArray(shopIds.map(Json.encodeString))], ["startDate", Json.encodeNumber(startDate)], ["endDate", Json.encodeNumber(endDate)], ["timeZone", Json.encodeString(I18n.timeZone)], ["exportType", Json.encodeString(toRawString(exportType))]]));
}
function make(shopIds, startDate, endDate, exportType) {
  return Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson(shopIds, startDate, endDate, exportType)
  }, undefined, undefined);
}
function mapError(error) {
  if (typeof error !== "object") {
    return "UnexpectedFailure";
  }
  let match = error._0;
  if (typeof match !== "object") {
    return "UnexpectedFailure";
  }
  if (match.TAG !== "InvalidRequestFailures") {
    return "UnexpectedFailure";
  }
  let match$1 = match._0;
  if (match$1.length !== 1) {
    return "UnexpectedFailure";
  }
  let match$2 = match$1[0];
  if (match$2.kind === "SalesExportDateRangeFailure") {
    return "DateRangeExceedingFailure";
  } else {
    return "UnexpectedFailure";
  }
}
function messageFromError(error) {
  if (error === "DateRangeExceedingFailure") {
    return I18n.t("sales_list_page_export_modal.export_request.date_range_exceeding_failure");
  } else {
    return I18n.t("sales_list_page_export_modal.export_request.unexpected_failure");
  }
}
function useDownload(request, shopIds, startDate, endDate, exportType) {
  let captureEvent = SessionTracker.useCaptureEvent();
  let request$1 = () => {
    captureEvent("download_sales_export_file");
    return request(shopIds, startDate, endDate, exportType);
  };
  let match = RequestOpenStorageUrl.use(request$1, undefined, undefined);
  let result = AsyncResult.mapError(match[0], mapError);
  return [result, match[1]];
}
let SalesExportRequest = {
  endpoint: endpoint,
  encodeRequestBodyJson: encodeRequestBodyJson,
  make: make,
  mapError: mapError,
  messageFromError: messageFromError,
  useDownload: useDownload
};
function SalesListPageExportModal(props) {
  let onRequestNotification = props.onRequestNotification;
  let onRequestOpenChange = props.onRequestOpenChange;
  let __request = props.request;
  let opened = props.opened;
  let request = __request !== undefined ? __request : make;
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let initialShopsFilterValue = activeShop !== undefined ? [activeShop] : shops;
  let now = new Date(Date.now());
  let initialDateRange_0 = DateHelpers.startOfMonth(now);
  let initialDateRange = [initialDateRange_0, now];
  let match = React.useState(() => initialShopsFilterValue);
  let setShopsFilterValue = match[1];
  let shopsFilterValue = match[0];
  let match$1 = React.useState(() => "All");
  let setExportType = match$1[1];
  let exportType = match$1[0];
  let match$2 = React.useState(() => initialDateRange);
  let setDateRange = match$2[1];
  let match$3 = match$2[0];
  let endDate = match$3[1];
  let startDate = match$3[0];
  let match$4 = useDownload(request, shopsFilterValue.map(shop => shop.id), startDate.getTime(), endDate.getTime(), exportType);
  let requestAndDownload = match$4[1];
  let operationResult = match$4[0];
  React.useEffect(() => {
    if (opened) {
      setShopsFilterValue(param => initialShopsFilterValue);
      setExportType(param => "All");
      setDateRange(param => initialDateRange);
    }
  }, [opened]);
  React.useEffect(() => {
    if (typeof operationResult === "object" && operationResult.TAG === "Done") {
      let error = operationResult._0;
      if (error.TAG === "Ok") {
        onRequestNotification({
          TAG: "Ok",
          _0: I18n.t("The file has been downloaded successfully.")
        });
      } else {
        onRequestNotification({
          TAG: "Error",
          _0: messageFromError(error._0)
        });
      }
    }
    onRequestOpenChange(false);
  }, [AsyncResult.isDone(operationResult)]);
  let newrecord = {
    ...{
      className: "backgroundColor-x17suf5r borderRadius-x12oqio5 display-x78zum5 justifyContent-xl56j7k padding-x1o8uwn5 width-xh8yej3",
      "data-style-src": "wino-gc:src/app/Sales/SalesListPageExportModal.res.js:28"
    }
  };
  let newrecord$1 = {
    ...{
      className: "alignSelf-xamitd3 height-x1ymw6g width-xzk1tus",
      "data-style-src": "wino-gc:src/app/Sales/SalesListPageExportModal.res.js:36"
    }
  };
  newrecord.children = JsxRuntime.jsx("img", (newrecord$1.src = illustrationSvg, newrecord$1));
  let tmp;
  if (shops.length > 1) {
    let items = shops.map(shop => ({
      TAG: "Option",
      key: shop.id,
      label: shop.name,
      value: [shop]
    }));
    tmp = JsxRuntime.jsx(Select.make, {
      label: I18n.t("Shop"),
      preset: {
        NAME: "inputField",
        VAL: {
          required: false
        }
      },
      sections: [{
        items: [{
          TAG: "Option",
          key: "default",
          label: I18n.template(I18n.t("All{{feminine}}"), undefined, undefined),
          value: shops,
          exclusive: true
        }]
      }, {
        items: items,
        title: I18n.t("Shops")
      }],
      value: {
        TAG: "Single",
        _0: shopsFilterValue
      },
      onChange: change => {
        if (change.TAG !== "Single") {
          return;
        }
        let v = change._0;
        setShopsFilterValue(param => v);
      }
    });
  } else {
    tmp = null;
  }
  let items$1 = values.map(value => ({
    TAG: "Option",
    key: toRawString(value),
    label: toLabel(value),
    value: value
  }));
  let newrecord$2 = {
    ...{
      className: "borderTopColor-x7i6r9d borderTopStyle-x13fuv20 borderTopWidth-x178xt8z display-x78zum5 gap-x167g77z justifyContent-x13a6bvl padding-x1tamke2",
      "data-style-src": "wino-gc:src/app/Sales/SalesListPageExportModal.res.js:46"
    }
  };
  return JsxRuntime.jsxs(Modal.make, {
    children: [JsxRuntime.jsxs(Box.make, {
      children: [JsxRuntime.jsx("div", newrecord), JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [tmp, JsxRuntime.jsx(Select.make, {
            label: I18n.t("Document type"),
            preset: {
              NAME: "inputField",
              VAL: {
                required: false
              }
            },
            sections: [{
              items: [{
                TAG: "Option",
                key: "default",
                label: I18n.template(I18n.t("All"), undefined, undefined),
                value: "All",
                exclusive: true
              }]
            }, {
              items: items$1,
              title: I18n.t("Type of sales")
            }],
            value: {
              TAG: "Single",
              _0: exportType
            },
            onChange: change => {
              if (change.TAG !== "Single") {
                return;
              }
              let value = change._0;
              setExportType(param => Stdlib_Option.getOr(value, "All"));
            }
          }), JsxRuntime.jsx(SelectDateRangeFilter.make, {
            value: [startDate, endDate],
            label: I18n.t("Period"),
            triggerPreset: {
              NAME: "inputField",
              VAL: {
                required: false
              }
            },
            placeholder: I18n.t("Select a period"),
            hideResetButton: true,
            onChange: dateRange => {
              if (dateRange === undefined) {
                return;
              }
              let end = dateRange[1];
              let start = dateRange[0];
              setDateRange(param => [start, end]);
            },
            triggerLabelDisplay: "showPreset"
          })],
          space: "normal",
          align: "center",
          grow: true
        }),
        spaceX: "normal",
        spaceY: "xxlarge"
      })],
      spaceX: "large",
      spaceTop: "large"
    }), JsxRuntime.jsxs("div", (newrecord$2.children = [JsxRuntime.jsx(Button.make, {
      label: I18n.t("Cancel"),
      onPress: () => onRequestOpenChange(false)
    }), JsxRuntime.jsx(Button.make, {
      label: I18n.t("sales_list_page.export_modal.commit_button"),
      variant: "solid",
      tone: "brand",
      pending: AsyncData.isBusy(operationResult),
      onPress: () => requestAndDownload()
    })], newrecord$2))],
    opened: opened,
    title: I18n.t("sales_list_page.export_modal.title"),
    hideFooter: true,
    onRequestClose: () => onRequestOpenChange(false)
  });
}
let make$1 = SalesListPageExportModal;
export { illustrationSvg, styles, SalesExportSaleType, SalesExportRequest, make$1 as make };
/* illustrationSvg Not a pure module */